export const DATE_SEPARATOR = 'date-separator'
export const MESSAGE = 'message'
export const ACTIVITY = 'activity'
export const NEW_MESSAGES_SEPARATOR = 'new-messages-separator'
